<div class="mt-28 py-28 bg-[#f2f2f2]">
  <h1 class="text-center text-4xl font-poppins font-bold mb-12">
    O que dizem os meus alunos?
  </h1>
  <div class="flex justify-evenly w-full 2xl:w-3/4 lg:w-11/12 m-auto flex-wrap">
    <div>
      <p class="text-center font-poppins font-bold text-xl my-6">Aluna Gilda</p>
      <video
        class="w-full md:w-96"
        controls
        controlslist="nodownload"
        src="https://fabiananano.com/wp-content/uploads/2022/02/Aprendeu-frances-com-facilidade-1.mp4">
        <track
          src="captions_en.vtt"
          kind="captions"
          srclang="en"
          label="english_captions" />
      </video>
    </div>
    <div>
      <p class="text-center font-poppins font-bold text-xl my-6">Aluna Thais</p>
      <img
        class="w-96"
        src="images/dpoimento-thais-min.png"
        alt="" />
    </div>
    <div>
      <p class="text-center font-poppins font-bold text-xl mb-6">Aluno Wellington</p>
      <img
        class="w-96"
        src="images/depoimento-wellington2.jpg"
        alt="" />
    </div>
  </div>
</div>
